export const cols_1=[
    {
        title:"排名",
        key:'rank',                   
        align:"center",                   
        width:'10vw',                   
    },
    {
        title:"季节",
        key:'seasonLogo',
        align:"center"         
    },
    {
        title:"批次",
        key:'batch',
        align:"center"      
    },
    {
        title:"SKC数",
        key:'skcNum',
        align:"center",        
    },
    
    {
        title:"已出版单总数",
        key:'patActualFinishNum',
        align:"center",        
    },
    {
        title:"出款完成率",
        key:'finshRate',
        align:"center",        
    }         
]

export const cols_2=[
    {
        title:"排名",
        key:'rank',                   
        align:"center",                   
        width:'10vw',                   
    },
    {
        title:"设计师",
        key:'designer',
        align:"center",      
    },
    {
        title:"商品总需求",
        key:'total',
        align:"center"      
    },
    {
        title:"已出款总数",
        key:'outTotal',
        align:"center",        
    },
    {
        title:"出款完成率",
        key:'outRate',
        align:"center",        
    },
    {
        title:"有效配色数",
        key:'activeTotal',
        align:"center",        
    }
        
]